import React from 'react';
import { css } from 'styled-components';

export default function Responsive({ ratio, width = undefined, children, className = undefined }) {
  return (
    <div
      css={css`
        width: ${width ? `${width}px` : '100%'};
        height: 0;
        content: '';
        display: block;
        padding-bottom: calc(100% / ${ratio});
      `}
    >
      <div
        css={css`
          position: absolute;
          left: 0;
          right: 0;
          bottom: 0;
          top: 0;
        `}
        className={className}
      >
        {children}
      </div>
    </div>
  );
}
